import gql from 'graphql-tag'

export const DELETE = gql`
  mutation order_delete($id: ID!) {
    orderDelete(id: $id) {
      id
    }
  }
`
